import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useNavigate } from 'react-router-dom';
import { useOperatorMessages } from '../../contexts/OperatorMessageContext';

interface Props {
  /** true면 목록 페이지로 이동, false면 작성 다이얼로그만 */
  openListOnClick?: boolean;
  color?: 'inherit' | 'default' | 'primary';
}

/** 통합/개별 관제 AppBar용 관제 메시지 아이콘 */
const OperatorMessageToolbarButton: React.FC<Props> = ({
  openListOnClick = false,
  color = 'inherit',
}) => {
  const { unreadCount, openCompose } = useOperatorMessages();
  const navigate = useNavigate();

  const onClick = () => {
    if (openListOnClick) {
      navigate('/operator-messages');
      return;
    }
    openCompose();
  };

  return (
    <Tooltip title={unreadCount > 0 ? `관제 메시지 (미읽음 ${unreadCount})` : '관제 메시지 작성'}>
      <IconButton color={color} onClick={onClick} size="small" aria-label="operator-messages">
        <Badge badgeContent={unreadCount} color="error" max={99}>
          <MailOutlineIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default OperatorMessageToolbarButton;
